var _circle, _circle2, _ellipse, _path, _circle3, _path2, _circle4, _path3, _path4, _circle5, _path5, _path6, _circle6, _path7, _path8, _circle7, _path9, _path0, _path1, _circle8, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpertise1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 124,
    viewBox: "0 0 126 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 65.8899,
    cy: 63.5788,
    r: 59.8601,
    stroke: "#E6EEFF",
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 65.312,
    cy: 64.1561,
    r: 39.6307,
    stroke: "#E6EEFF",
    strokeWidth: 0.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 65.2294,
    cy: 63.8073,
    rx: 20.2294,
    ry: 20.8073,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5755 56.2981C68.2413 56.8117 68.3953 57.811 67.9199 58.5301L65.3603 62.3999H68.4075C68.9624 62.3999 69.4709 62.735 69.7247 63.268C69.9787 63.8007 69.9354 64.4424 69.613 64.9299L65.3801 71.3298C64.9046 72.049 63.9792 72.2155 63.3135 71.7018C62.6477 71.1883 62.4934 70.1889 62.9691 69.4699L65.5287 65.6H62.4815C61.9265 65.6 61.4181 65.265 61.1642 64.732C60.9103 64.1993 60.9534 63.5576 61.276 63.07L65.5087 56.6701C65.9843 55.9511 66.9095 55.7845 67.5755 56.2981Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.395,
    cy: 101.148,
    r: 9.82569,
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.377 100.3C112.132 100.3 111.934 100.102 111.934 99.857C111.934 99.6124 112.132 99.4141 112.377 99.4141H113.854C114.098 99.4141 114.296 99.6124 114.296 99.857V101.333C114.296 101.578 114.098 101.776 113.854 101.776C113.609 101.776 113.411 101.578 113.411 101.333V100.926L112.222 102.115C111.818 102.519 111.164 102.519 110.76 102.115L109.824 101.178C109.766 101.121 109.673 101.121 109.615 101.178L108.261 102.533C108.088 102.706 107.807 102.706 107.634 102.533C107.461 102.36 107.461 102.079 107.634 101.906L108.989 100.552C109.392 100.148 110.047 100.148 110.45 100.552L111.387 101.489C111.444 101.546 111.538 101.546 111.596 101.489L112.784 100.3H112.377Z",
    fill: "#306EFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.4771,
    cy: 9.82569,
    r: 9.82569,
    fill: "#484848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2045 9.82546C32.2045 11.4215 30.9107 12.7154 29.3146 12.7154C27.7185 12.7154 26.4247 11.4215 26.4247 9.82546C26.4247 8.2294 27.7185 6.93555 29.3146 6.93555C30.9107 6.93555 32.2045 8.2294 32.2045 9.82546Z",
    fill: "#306EFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3782 7.46016C31.7564 7.39031 32.1029 7.36665 32.3886 7.40502C32.6669 7.44239 32.9434 7.54726 33.095 7.78966C33.2562 8.04733 33.2077 8.34654 33.0906 8.6052C32.9717 8.86804 32.7589 9.1466 32.4866 9.42454C31.9392 9.98326 31.1009 10.5899 30.1035 11.1213C29.1057 11.6529 28.1187 12.0186 27.3243 12.176C26.9286 12.2544 26.5664 12.284 26.2685 12.2486C25.9795 12.2143 25.6907 12.1103 25.5344 11.8605C25.3643 11.5886 25.4273 11.2716 25.5595 11.0009C25.695 10.7237 25.9326 10.4281 26.2358 10.1329L26.4248 9.97553C26.4248 10.0544 26.4549 10.2317 26.4855 10.3895C26.5016 10.4723 26.5178 10.5498 26.5299 10.6048C26.2944 10.8451 26.1333 11.0609 26.0463 11.2388C25.9462 11.4438 25.9711 11.537 25.9937 11.5731C26.02 11.6151 26.1039 11.6834 26.3325 11.7106C26.5522 11.7367 26.8525 11.7171 27.219 11.6445C27.9491 11.4998 28.8855 11.1562 29.8487 10.6431C30.8123 10.1297 31.6013 9.5539 32.0996 9.04532C32.3501 8.78962 32.5148 8.56337 32.597 8.38181C32.681 8.19607 32.6571 8.11131 32.6357 8.07706C32.6103 8.03652 32.5312 7.97089 32.3165 7.94205C32.1209 7.91579 31.857 7.92714 31.5351 7.98257L31.0738 7.53337C31.1962 7.49673 31.3116 7.4717 31.3782 7.46016Z",
    fill: "#7BA1F9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.459,
    cy: 21.3843,
    r: 9.82569,
    fill: "#484848"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.214 17.6624C101.214 17.4843 101.07 17.3398 100.891 17.3398C100.713 17.3398 100.569 17.4843 100.569 17.6624V26.265C100.569 26.4431 100.713 26.5876 100.891 26.5876C101.07 26.5876 101.214 26.4431 101.214 26.265V22.7594V18.4582V17.6624Z",
    fill: "#81A6FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.25 18.5705L104.072 18.4994C103.4 18.2305 102.664 18.1629 101.954 18.3049L101.214 18.4529V22.7542L101.954 22.6062C102.664 22.4642 103.4 22.5317 104.072 22.8006C104.801 23.092 105.602 23.1464 106.364 22.9561L106.407 22.9454C106.659 22.8823 106.778 22.5937 106.645 22.3709L105.973 21.2521C105.826 21.0073 105.753 20.8849 105.736 20.7517C105.728 20.6962 105.728 20.6399 105.736 20.5844C105.753 20.4513 105.826 20.3289 105.973 20.084L106.523 19.1675C106.667 18.9276 106.449 18.6335 106.178 18.7013C105.537 18.8614 104.863 18.8156 104.25 18.5705Z",
    fill: "#306EFF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.459,
    cy: 56.064,
    r: 9.82569,
    fill: "#484848"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.42 54.8688C104.527 54.8688 105.424 53.9717 105.424 52.8651C105.424 51.7584 104.527 50.8613 103.42 50.8613C102.314 50.8613 101.417 51.7584 101.417 52.8651C101.417 53.9717 102.314 54.8688 103.42 54.8688Z",
    fill: "#306EFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107.428 58.6273C107.428 59.8722 107.428 60.8815 103.42 60.8815C99.4128 60.8815 99.4128 59.8722 99.4128 58.6273C99.4128 57.3823 101.207 56.373 103.42 56.373C105.634 56.373 107.428 57.3823 107.428 58.6273Z",
    fill: "#7BA1F9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.532,
    cy: 102.304,
    r: 9.82569,
    fill: "#484848"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4166 102.188C60.9488 102.188 62.1909 101.567 62.1909 100.801C62.1909 100.035 60.9488 99.4141 59.4166 99.4141C57.8844 99.4141 56.6423 100.035 56.6423 100.801C56.6423 101.567 57.8844 102.188 59.4166 102.188Z",
    fill: "#306EFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M56.6423 102.883V104.964C56.6423 105.73 57.8844 106.351 59.4166 106.351C60.9488 106.351 62.1909 105.73 62.1909 104.964V102.883C62.1909 103.649 60.9488 104.27 59.4166 104.27C57.8844 104.27 56.6423 103.649 56.6423 102.883Z",
    fill: "#9AB8FF",
    fillOpacity: 0.7
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M56.6423 100.801V102.881C56.6423 103.648 57.8844 104.269 59.4166 104.269C60.9488 104.269 62.1909 103.648 62.1909 102.881V100.801C62.1909 101.567 60.9488 102.188 59.4166 102.188C57.8844 102.188 56.6423 101.567 56.6423 100.801Z",
    fill: "#306EFF",
    fillOpacity: 0.6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.82569,
    cy: 81.8257,
    r: 9.82569,
    fill: "#484848"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8367 85.2232C8.61214 85.6301 8.99986 85.8336 9.41696 85.8336V81.4166L5.28181 79.2402C5.27572 79.25 5.26974 79.2599 5.26387 79.2699C5 79.718 5 80.2756 5 81.3908V81.4425C5 82.5577 5 83.1153 5.26387 83.5634C5.52773 84.0115 6.00293 84.2609 6.95331 84.7596L7.8367 85.2232Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M11.8805 78.074L10.9971 77.6104C10.2217 77.2035 9.83399 77 9.41689 77C8.9998 77 8.61208 77.2035 7.83663 77.6104L6.95323 78.074C6.02401 78.5616 5.54906 78.8109 5.28174 79.2406L9.41689 81.417L13.552 79.2406C13.2847 78.8109 12.8097 78.5616 11.8805 78.074Z",
    fill: "#5687FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.57 79.2699C13.5641 79.2599 13.5581 79.25 13.552 79.2402L9.41687 81.4166V85.8336C9.83396 85.8336 10.2217 85.6301 10.9971 85.2232L11.8805 84.7596C12.8309 84.2609 13.3061 84.0115 13.57 83.5634C13.8338 83.1153 13.8338 82.5577 13.8338 81.4425V81.3908C13.8338 80.2756 13.8338 79.718 13.57 79.2699Z",
    fill: "#97B6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertise1);
export default __webpack_public_path__ + "static/media/expertise-1.7ffcfb0a1eb5bf75c0a00232b6132eb1.svg";
export { ForwardRef as ReactComponent };